import { render, staticRenderFns } from "./Neumaticos.vue?vue&type=template&id=cfdbe3ca"
import script from "./Neumaticos.vue?vue&type=script&lang=js"
export * from "./Neumaticos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports